module.exports = __webpack_public_path__ + "img/bf-plus.3adeac22.svg";